import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { FormControl, FormGroup as BaseFormGroup } from 'react-bootstrap'
import cx from 'classnames'

import FormErrors from './FormErrors'

export default function FormGroup({
  children,
  className,
  controlId,
  errorKey,
  errors,
  feedback = true,
  required = false,
  validationState,
  ...props
}) {
  let hasErrors = false

  if (errors && errorKey) {
    if (typeof errorKey === 'string') {
      errorKey = [errorKey]
    }

    errorKey = errorKey.filter(key => errors.has(key))
    hasErrors = errorKey.length > 0
  }

  className = cx(className, { required })

  if (feedback === true) {
    feedback = hasErrors ? <FormControl.Feedback /> : null
  }

  if (!validationState && validationState !== false && hasErrors) {
    validationState = 'error'
  }

  if (!validationState) {
    validationState = undefined
  }

  return (
    <BaseFormGroup
      className={className}
      validationState={validationState}
      data-controlId={controlId}
      controlId={controlId}
      {...props}
    >
      {children}
      {feedback}
      {hasErrors && errorKey.map(key => <FormErrors key={key} errors={errors.get(key)} />)}
    </BaseFormGroup>
  )
}

FormGroup.propTypes = {
  children: Pt.node.isRequired,
  className: Pt.string,
  controlId: Pt.string,
  errorKey: Pt.oneOfType([
    Pt.string,
    Pt.arrayOf(Pt.string),
  ]),
  errors: Ipt.map,
  feedback: Pt.oneOfType([Pt.node, Pt.bool]),
  required: Pt.bool,
  validationState: Pt.oneOfType([Pt.string, Pt.bool]),
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/FormGroup.jsx